<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>智能通道翼闸</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>智能通道翼闸</h2>
          <p>
            翼闸是人流通道的控制设备。用于人员出、入口需要进行控制的地方，如饭 堂、宾馆、博物馆、体育馆、俱乐部、地铁、车站、码头等场所。翼闸的使 用可以使人流有序的通过通道。 翼闸与IC卡读写器结合，便构成智能翼闸；智能翼闸与计算机、门禁考勤收 费管理软件结合，构成智能翼闸综合管理系统，可以实现门禁、考勤、限 流等功能,还有收费功能。
            本翼闸管理系统是“一卡通”的一部分，设置于小区、厂房、大厦、饭堂 等通道处，可以完成员工持卡通行管制、上下班考勤、就餐等各种管理功能。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>智能卡</h2>
          <p>系统采用非接触式智能射频卡，成功的解决了一卡多用、保 密、无磨损、操作简便等问题，大大提高了系统的实用性。</p>
        </li>
        <li>
          <h2>扩容方便</h2>
          <p>计算机与智能翼闸采用RS485总线通讯，因此扩容方便。即 当安装了相应的控制系统后，根据需要，若须增加智能翼闸数量，硬件仅 须增加相应的智能翼闸，软件对新增设备进行设置即可。</p>
        </li>
        <li>
          <h2>脱机工作</h2>
          <p>脱机运行智能翼闸不仅可与计算机连网运行，而且还可以脱机工作。智 能翼闸根据系统下载的参数，自动判断用户卡是否有效，决定是否开闸，并 把开闸记录存于存储器中。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SsintelligentChannel',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
